import React, { useState } from "react";
import {
  CartesianGrid,
  Cell,
  Line,
  LineChart,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { FaTimesCircle } from "react-icons/fa";
import DealsTable from "../DealerShipDashBoard/DealsTable";
import { useTheme } from "../BrandColors/Context/ThemeContext";

const DealerShipDashBoard = () => {
  const dealershipTheme = useTheme();

  const user = JSON.parse(localStorage.getItem("user"));
  const theme = user?.role === "DealershipAdmin" ? dealershipTheme : "#3b82f6";

  const data = [
    { month: "Jan", revenue: 400, sales: 240 },
    { month: "Feb", revenue: 300, sales: 139 },
    { month: "Mar", revenue: 500, sales: 400 },
    { month: "Apr", revenue: 478, sales: 390 },
    { month: "May", revenue: 589, sales: 480 },
    { month: "Jun", revenue: 639, sales: 500 },
    { month: "Jul", revenue: 749, sales: 600 },
    { month: "Aug", revenue: 800, sales: 700 },
    { month: "Sep", revenue: 900, sales: 800 },
    { month: "Oct", revenue: 1000, sales: 850 },
    { month: "Nov", revenue: 1200, sales: 950 },
    { month: "Dec", revenue: 1300, sales: 1000 },
  ];

  const data2 = [
    { name: "Group A", value: 500 },
    { name: "Group B", value: 300 },
  ];

  const COLORS = ["url(#gradient)", "#1e293b"];

  const hasMainDataModule = user?.assignedProducts?.some(
    (product) => product.product._id === "6762a7e4b3f3a172eb46a895"
  );

  const handleMainDataClick = () => {
    const link = "https://admin.provaantech.com/demo";
    window.open(link, "_blank");
  };

  return (
    <div className="w-full flex flex-col gap-6 animate-fade-in-up">
      <header className="mb-2">
        <h1 className="text-3xl font-bold text-slate-900 flex items-center gap-3">
          Welcome, <span style={{ color: theme }}>{user?.email?.split("@")[0].charAt(0).toUpperCase() + user?.email?.split("@")[0].slice(1)}</span>
        </h1>
        <p className="text-slate-600 mt-1">Dealership {`(${user?.role})`}</p>
      </header>

      {/* Top Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">

        {/* Card 1 */}
        <div className="glass-card p-6 flex flex-col justify-between relative overflow-hidden group">
          <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-transparent to-white/5 rounded-bl-full pointer-events-none"></div>
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center shadow-lg" style={{ backgroundColor: theme }}>
              <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 hite" viewBox="0 -960 960 960" fill="currentColor"><path d="m200-553.67 96.67 41Q313.33-546 332-578q18.67-32 40-62l-71.33-14.33L200-553.67ZM350-472l126.67 126.33q52-22.66 101.33-55.66T662-469q77.33-77.33 115.83-162.5T816.67-812q-95.34.33-180.67 38.83-85.33 38.5-162.67 115.84-34.66 34.66-67.66 84Q372.67-524 350-472Zm212-85.67q-21-21-21-51.83t21-51.83q21-21 52-21t52 21q21 21 21 51.83t-21 51.83q-21 21-52 21t-52-21Zm-3.67 362.34L659-296l-14.33-71.33q-30 21.33-62 39.83t-65.34 35.17l41 97ZM880-875.67q12.33 131-30.5 243.84Q806.67-519 706-418.33q-.67.66-1.33 1.33-.67.67-1.34 1.33l21.34 106.34Q728-292.67 723-277q-5 15.67-17 27.67L536-78.67l-84.67-197.66L281-446.67 83.33-531.33l170.34-170q12-12 27.83-17 15.83-5 32.5-1.67l106.33 21.33q.67-.66 1.34-1 .66-.33 1.33-1 100.67-100.66 213.33-144Q749-888 880-875.67Zm-728.33 552q35-35 85.5-35.5t85.5 34.5q35 35 34.5 85.5t-35.5 85.5q-25.67 25.67-81.5 43-55.84 17.34-162.84 32Q92-185.67 109-241.83q17-56.17 42.67-81.84Zm47 47.34Q186-263 175.33-232.83q-10.66 30.16-17.33 72.5 42.33-6.67 72.5-17.17 30.17-10.5 43.5-23.17 16.67-15.33 17.33-38Q292-261.33 276-278q-16.67-16-39.33-15.5-22.67.5-38 17.17Z" /></svg>
            </div>
          </div>
          <div>
            <h3 className="text-3xl font-bold  mb-1">75,000</h3>
            <p className="text-sm text-slate-600 font-medium">Total Pre Sales Views</p>
          </div>
        </div>

        {/* Card 2 */}
        <div className="glass-card p-6 flex flex-col justify-between relative overflow-hidden group">
          <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-transparent to-white/5 rounded-bl-full pointer-events-none"></div>
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center shadow-lg" style={{ backgroundColor: theme }}>
              <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 hite" viewBox="0 -960 960 960" fill="currentColor"><path d="M546.67-426.67q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35ZM240-293.33q-27.5 0-47.08-19.59-19.59-19.58-19.59-47.08v-373.33q0-27.5 19.59-47.09Q212.5-800 240-800h613.33q27.5 0 47.09 19.58Q920-760.83 920-733.33V-360q0 27.5-19.58 47.08-19.59 19.59-47.09 19.59H240ZM333.33-360H760q0-39 27.17-66.17 27.16-27.16 66.16-27.16V-640q-39 0-66.16-27.17Q760-694.33 760-733.33H333.33q0 39-27.16 66.16Q279-640 240-640v186.67q39 0 66.17 27.16Q333.33-399 333.33-360ZM800-160H106.67q-27.5 0-47.09-19.58Q40-199.17 40-226.67V-680h66.67v453.33H800V-160ZM240-360v-373.33V-360Z" /></svg>
            </div>
          </div>
          <div>
            <h3 className="text-3xl font-bold hite mb-1">500</h3>
            <p className="text-sm text-slate-600 font-medium">New Leads</p>
          </div>
        </div>

        {/* Card 3 */}
        <div className="glass-card p-6 flex flex-col justify-between relative overflow-hidden group">
          <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-transparent to-white/5 rounded-bl-full pointer-events-none"></div>
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center shadow-lg" style={{ backgroundColor: theme }}>
              <FaTimesCircle className="w-6 h-6 hite" />
            </div>
          </div>
          <div>
            <h3 className="text-3xl font-bold hite mb-1">75,000</h3>
            <p className="text-sm text-slate-600 font-medium">Total Closed</p>
          </div>
        </div>

        {/* Card 4 */}
        <div className="glass-card p-6 flex flex-col justify-between relative overflow-hidden group">
          <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-transparent to-white/5 rounded-bl-full pointer-events-none"></div>
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center shadow-lg" style={{ backgroundColor: theme }}>
              <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 hite" viewBox="0 -960 960 960" fill="currentColor"><path d="M437.67-82q-76-8-141.17-41.83-65.17-33.84-113.5-87.67t-75.67-122.83Q80-403.33 80-480.67 80-636.33 182.83-750q102.84-113.67 255.5-129.33v67q-125 17.66-208.33 111.5-83.33 93.83-83.33 220.16 0 126.34 83 220.17 83 93.83 208 111.5v67ZM447-280v-271.67L327.67-432.33 280.33-480l200-200 200 200-47.66 47.33-119-119V-280H447Zm76 198v-67q45.33-5.67 86.83-23t76.5-45.33l48.34 48.66q-45.67 35.34-99.34 58.34Q581.67-87.33 523-82Zm163.67-661.33Q650.33-770 609.33-788T523-812.33v-67q58.67 6.66 112 29.33 53.33 22.67 99.67 58l-48 48.67ZM791.33-229l-47.66-47q28-35.67 45-77.17T811.33-440H879q-6.67 58.67-29.17 112.33-22.5 53.67-58.5 98.67Zm20-292.33q-5.66-45.34-22.66-87.17t-45-76.83L794-731.67q35.33 45.67 57.17 99Q873-579.33 879-521.33h-67.67Z" /></svg>
            </div>
          </div>
          <div>
            <h3 className="text-3xl font-bold hite mb-1">500</h3>
            <p className="text-sm text-slate-600 font-medium">Pending Follow-up</p>
          </div>
        </div>
      </div>

      {/* Graphs Section */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

        {/* Target Pie Chart */}
        <div className="glass-panel p-6 lg:col-span-1 flex flex-col relative overflow-hidden">
          <h3 className="text-xl font-bold hite mb-1">Target</h3>
          <p className="text-sm text-slate-600 mb-6">Revenue Target Progress</p>

          <div className="flex-1 flex flex-col items-center justify-center relative">
            <PieChart width={220} height={120}>
              <defs>
                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor={theme} />
                  <stop offset="100%" stopColor="#8b5cf6" />
                </linearGradient>
              </defs>
              <Pie
                data={data2}
                cx="50%"
                cy="100%"
                startAngle={180}
                endAngle={0}
                innerRadius={70}
                outerRadius={95}
                dataKey="value"
                stroke="none"
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index]} />
                ))}
              </Pie>
            </PieChart>
            <div className="absolute bottom-2 text-center w-full flex flex-col items-center">
              <p className="text-sm text-slate-600">Total earning</p>
              <p className="text-2xl font-bold hite">$240</p>
            </div>
          </div>

          <div className="mt-6 pt-4 border-t border-blue-200/50 flex justify-between items-end">
            <div>
              <p className="text-xs text-slate-600 mb-1">Target Revenue Today</p>
              <p className="text-2xl font-bold" style={{ color: theme }}>$44</p>
            </div>
            <div className="text-right">
              <p className="text-xs text-slate-600 max-w-[140px] leading-tight">It is higher than yesterday</p>
            </div>
          </div>
        </div>

        {/* Statistics Line Chart */}
        <div className="glass-panel p-6 lg:col-span-2">
          <h3 className="text-xl font-bold hite mb-1">Statistics</h3>
          <p className="text-sm text-slate-600 mb-6">Revenue and Leads Over Time</p>

          <div className="w-full h-72">
            <ResponsiveContainer width='100%' height='100%'>
              <LineChart data={data} margin={{ top: 5, right: 30, left: -20, bottom: 5 }}>
                <defs>
                  <linearGradient id="gradientLine" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor={theme} />
                    <stop offset="100%" stopColor="#8b5cf6" />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="#334155" vertical={false} />
                <XAxis dataKey="month" stroke="#94a3b8" tick={{ fill: '#94a3b8', fontSize: 12 }} axisLine={false} tickLine={false} dy={10} />
                <YAxis domain={[100, 1400]} tickCount={6} stroke="#94a3b8" tick={{ fill: '#94a3b8', fontSize: 12 }} axisLine={false} tickLine={false} dx={-10} />
                <Tooltip
                  contentStyle={{ backgroundColor: '#1e293b', border: '1px solid #334155', borderRadius: '8px', color: '#f8fafc' }}
                  itemStyle={{ color: '#e2e8f0' }}
                />
                <Line type="monotone" dataKey="revenue" stroke="url(#gradientLine)" strokeWidth={3} dot={{ r: 4, fill: '#0f172a', strokeWidth: 2 }} activeDot={{ r: 6, fill: theme }} />
                <Line type="monotone" dataKey="sales" stroke="#64748b" strokeWidth={2} dot={false} strokeDasharray="5 5" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

      </div>

      {/* Utilities */}
      {hasMainDataModule && (
        <div className="flex justify-end">
          <button
            className="flex items-center gap-2 px-6 py-2.5 rounded-lg hite font-medium transition-all shadow-lg active:scale-95 hover:opacity-90"
            style={{ backgroundColor: theme }}
            onClick={handleMainDataClick}
          >
            <svg xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="20" height="20px" viewBox="0 -960 960 960" width="20px" fill="currentColor"><path d="M120-233.33V-300h66.67v66.67H120Zm0-153.34v-66.66h66.67v66.66H120ZM120-540v-66.67h66.67V-540H120ZM273.33-80v-66.67H340V-80h-66.67Zm73.34-160q-27 0-46.84-19.83Q280-279.67 280-306.67v-506.66q0-27 19.83-46.84Q319.67-880 346.67-880h386.66q27 0 46.84 19.83Q800-840.33 800-813.33v506.66q0 27-19.83 46.84Q760.33-240 733.33-240H346.67Zm0-66.67h386.66v-506.66H346.67v506.66Zm80 226.67v-66.67h66.66V-80h-66.66Zm-240 0q-27.5 0-47.09-19.58Q120-119.17 120-146.67h66.67V-80ZM580-80v-66.67h66.67q0 27.67-19.59 47.17Q607.5-80 580-80ZM120-693.33q0-27.5 19.58-47.09Q159.17-760 186.67-760v66.67H120ZM540-560Z" /></svg>
            Copy Demo Main Stepper Data
          </button>
        </div>
      )}

      {/* Deals Table */}
      <DealsTable />
    </div>
  );
};

export default DealerShipDashBoard;